import { render, staticRenderFns } from "./laporanbulanan.vue?vue&type=template&id=3d122fa2&"
import script from "./laporanbulanan.vue?vue&type=script&lang=js&"
export * from "./laporanbulanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports